var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21 3.883l-.081.07-2.91 2.983-.012.012a.603.603 0 00-.052.065l.063-.077a.602.602 0 00-.17.42v.033l.004.037-.004-.07a.602.602 0 00.107.342l.07.082 2.91 2.9a.6.6 0 00.916-.768l-.07-.083-1.88-1.874h4.892a3.207 3.207 0 013.201 3.025l.005.182v1.623a.6.6 0 001.192.097l.008-.097v-1.623A4.407 4.407 0 009.206 6.76l-.213-.005h-4.92l1.914-1.963a.6.6 0 00.06-.766l-.07-.083a.6.6 0 00-.766-.06z",
    fill: "var(--icon-dark-gray)",
    fillRule: "nonzero"
  })));
}
export default SvgReply;